export default __webpack_public_path__ + "static/media/mn_tea_head_2.e78eac9f.png";